import React from "react";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

/**
 * DisplayRating Component
 * Renders a 5-star rating with full, half, and empty stars.
 * 
 * Props:
 * - rating (number): The rating value, e.g. 4.3
 */
const DisplayRating = ({ rating = 0 }) => {
  const renderStars = () => {
    const stars = [];

    // Ensure rating stays between 0 and 5
    const normalized = Math.min(Math.max(rating, 0), 5);

    const fullStars = Math.floor(normalized);
    const decimal = normalized - fullStars;
    const hasHalfStar = decimal >= 0.25 && decimal < 0.75; // More natural threshold
    const totalDisplayed = fullStars + (hasHalfStar ? 1 : 0);
    const emptyStars = 5 - totalDisplayed;

    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} />);
    }

    // Half star (if applicable)
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" />);
    }

    // Empty stars
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }

    return stars;
  };

  return (
    <ul className="rating-stars" style={{ display: "flex", gap: "2px", listStyle: "none", padding: 0, margin: 0 }}>
      {renderStars().map((star, index) => (
        <li key={index}>{star}</li>
      ))}
    </ul>
  );
};

export default DisplayRating;
